module.exports = __webpack_public_path__ + "img/omise.0250258b.png";